import { useMemo } from 'react';

import { businessTimezone } from '@/utilities/businessTimezone';

import { useClientUser } from './useClientUser';

// Resource schedule bounds are written at midnight in the client's own zone, so every reader has to
// resolve the same one. Memoised because it feeds dependency arrays across the plan page.
export const useBusinessTimezone = () => {
    const { businessZip } = useClientUser();

    return useMemo(() => businessTimezone(businessZip), [businessZip]);
};
